import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  ListItemIcon,
  Divider,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import LockResetIcon from '@mui/icons-material/LockReset';
import { useEasyBrowserContext } from '../browser';
import tokenService from '../../../services/tokenservice';
import { useNavigate } from 'react-router'; // Importando o novo modal
import ModalTrocarSenha from '../../usuario/usuariomodalsenha';

const UsuarioMenu = React.forwardRef((_props: unknown, _ref: React.ForwardedRef<any>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isTrocarSenhaModalOpen, setIsTrocarSenhaModalOpen] = useState(false); // Novo estado do modal
  const open = Boolean(anchorEl);
  const { usuario } = useEasyBrowserContext()!;

  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onSair = async () => {
    await tokenService.deleteToken();
    navigate("/login");
  }

  const onTrocarSenha = () => {
    handleClose(); // Fecha o menu
    setIsTrocarSenhaModalOpen(true); // Abre o modal
  }

  return (
    <>
      <IconButton onClick={handleClick} size="small" sx={{ ml: 1 }}>
        <Avatar sx={{ width: 32, height: 32 }} src={`data:image/png;base64,${usuario.foto}`}>
          {usuario.nome?.[0]?.toUpperCase() ?? 'U'}
        </Avatar>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={onTrocarSenha}>
          <ListItemIcon>
            <LockResetIcon fontSize="small" />
          </ListItemIcon>
          Trocar Senha
        </MenuItem>

        <Divider />

        <MenuItem onClick={onSair}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          Sair
        </MenuItem>
      </Menu>
      
      {/* 2. Incluindo o Modal */}
      <ModalTrocarSenha
        open={isTrocarSenhaModalOpen} 
        onClose={() => setIsTrocarSenhaModalOpen(false)} 
        usuarioCodigo={usuario.codigo}
      />
    </>
  );
});
export default UsuarioMenu;